import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../_services/auth.service';
import { NotificationService, NotificationType } from '../../_services/notification.service'

import { FormControl, Validators, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(private _router: Router,
    private _authService: AuthService,
    private _notificationService: NotificationService, ) { }

  ngOnInit() {
    this.forgotPasswordForm.reset();
  }

  sendForgotPassword() {
    let notificationID = this._notificationService.showNotification({
      message: "Checking..",
      type: NotificationType.info,
      isLoading: true
    })
    this._notificationService.notificationID.push(notificationID);

    this._authService.requestResetPassowrd(this.forgotPasswordForm.value).subscribe((result) => {
      let notifyID = this._notificationService.notificationID.shift();
      this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
      this.forgotPasswordForm.reset();
      setTimeout(() => {
        window.location.replace('/auth/login');
      }, 1000);
    }, (error) => {
      if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
      }
    })

  }

}
